export default "__VITE_ASSET__22dEx6U1__"